import type { DataResponse, MeResponse, UpdateProfileInput } from '@tracker/shared';
import { api } from '@/lib/api';

export const profileService = {
  async getMe(): Promise<MeResponse> {
    const res = await api.get<DataResponse<MeResponse>>('/profile/me');
    return res.data.data;
  },

  async updateMe(input: UpdateProfileInput): Promise<MeResponse> {
    const res = await api.patch<DataResponse<MeResponse>>('/profile/me', input);
    return res.data.data;
  },
};
